let env
if (process !== undefined &&
  process.versions != null &&
  process.versions.node != null) { // nodejs
  env = process.env.NODE_ENV || 'development'
} else if (window && window.location && window.location.hostname) { // browser
  const isLocalhost = Boolean(
    window.location.hostname === 'localhost' ||
    // [::1] is the IPv6 localhost address.
    window.location.hostname === '[::1]' ||
    // 127.0.0.1/8 is considered localhost for IPv4.
    window.location.hostname.match(
      /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/,
    ),
  )
  // eslint-disable-next-line eqeqeq
  const isTest = (window.location.host == 'test.go.knackly.io')
  env = isLocalhost ? 'development' : isTest ? 'test' : 'production'
}

exports.env = env

const isDev = env === 'development'
exports.isDev = isDev
const isTest = env === 'test'
exports.isTest = isTest

const isProd = !isDev && !isTest
exports.isProd = isProd
